import assetsBase from '@exodus/assets-base'
import { create } from 'superstruct'
import { Quote } from '../schema/quote.js'
import { createPaymentMethodValidator } from '../payment-method.js'
import { PROVIDERS } from '../constants.js'
import {
  DEFAULT_CRYPTO_PRECISION,
  DEFAULT_FIAT_PRECISION,
  DEFAULT_MAX,
  DEFAULT_MIN,
  ENABLED_ASSETS,
  PAYMENT_METHODS,
} from './constants.js'

const assets = assetsBase.default || assetsBase

const fromProviderToExodusAsset = (asset, network, assets_ = ENABLED_ASSETS) =>
  assets[assets_[`${asset.toLowerCase()}_${network.toLowerCase()}`]]

const fromExodusToProviderAsset = (asset, assets_ = ENABLED_ASSETS) =>
  Object.fromEntries(Object.entries(assets_).map((entry) => entry.reverse()))
    [asset]?.toUpperCase()
    ?.split('_') ?? []

const fromExodusToProviderPaymentMethod = (paymentMethod, parameters = Object.create(null)) => {
  if (!paymentMethod) {
    throw new Error('Payment method is required')
  }

  const providerPaymentMethod = [...PAYMENT_METHODS.values()].find(
    createPaymentMethodValidator({ ...parameters, type: paymentMethod })
  )

  return providerPaymentMethod?.id
}

const fromProviderToExodusPaymentMethod = (paymentMethod) => {
  if (!paymentMethod) {
    throw new Error('Payment method is required')
  }

  const type = PAYMENT_METHODS.get(paymentMethod)?.type
  return Array.isArray(type) ? type[0] : type
}

const fromProviderToExodusQuote = ({ networkFee, processingFee, type, ...quote }) => {
  const networkFeeFiat = Number(networkFee.fiatAmount) || 0
  const processingFeeFiat = Number(processingFee.fiatAmount) || 0
  const totalFeeFiat = networkFeeFiat + processingFeeFiat

  const asset = fromProviderToExodusAsset(quote.assetCode, quote.networkCode)
  const cryptoAmount = asset.currency.defaultUnit(quote.cryptoAmount)
  const networkFeeCrypto = asset.currency.defaultUnit(networkFee.cryptoQuantity)
  const processingFeeCrypto = asset.currency.defaultUnit(processingFee.cryptoQuantity)
  const totalFeeCrypto = networkFeeCrypto.add(processingFeeCrypto)

  return create(
    {
      extraFee: 0,
      fee: processingFeeCrypto.toDefaultNumber(),
      from: {
        amount: Number(quote.fiatAmount),
        asset: quote.fiatCode,
        maxBuyAmount: DEFAULT_MAX,
        minBuyAmount: DEFAULT_MIN,
        precision: DEFAULT_FIAT_PRECISION,
      },
      networkFee: networkFeeCrypto.toDefaultNumber(),
      paymentMethod: quote.paymentMethod,
      provider: PROVIDERS.robinhood,
      rate: Number(quote.price),
      to: {
        amount: cryptoAmount.toDefaultNumber(),
        asset: asset.name,
        maxBuyAmount: DEFAULT_MAX,
        minBuyAmount: DEFAULT_MIN,
        precision: DEFAULT_CRYPTO_PRECISION,
      },
      totalAmount: Number(quote.fiatAmount),
      totalFee: totalFeeFiat,
      totalFeeCrypto: totalFeeCrypto.toDefaultNumber(),
      type,
    },
    Quote
  )
}

const robinhoodAdapter = {
  fromExodusToProviderAsset,
  fromExodusToProviderPaymentMethod,
  fromProviderToExodusAsset,
  fromProviderToExodusPaymentMethod,
  fromProviderToExodusQuote,
}

export default robinhoodAdapter
